<template>
  <div id="production_of_electricity_ship">
    <div 
      v-if="receivedData"
      class="production_of_electricity-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="line"
          index-axis="x"
          :id="'production_of_electricity-ozon'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>
    <div 
      v-if="receivedData"
      class="production_of_electricity-item"
    >
      <TabsCustomGraphic
          :received-data="receivedData[1]"
          :id="'production_of_electricity-ozon-2'"
          :aspect-ratio="1"
          index-axis="x"
          graph-type="bar"
          :maintain-aspect-ratio="true"
      />
    </div>
  </div>
</template>
<script>
import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductionOfElectricity',

  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'production_of_electricity',
      cloneElementId: 'production_of_electricity_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '54,55,56,57,58').then((response) => {
        this.receivedData = []
        this.receivedData[0] = response.data[0]
        this.receivedData[1] = response.data.slice(1)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .production_of_electricity-item {
    margin-top: 40px;
  }
</style>